/**
 * 底部按钮
 */
import React, { MouseEventHandler, useEffect, useState } from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

interface Props {
  title: string | React.ReactElement<any, any>;
  fixed: boolean;
  reverse: boolean;
  round: boolean;
  bgColor?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  disabled?: boolean;
  className?: string;
  btnClassName?: string;
  showBorderTop?: boolean;
  evaluatePadding?: string;
  extra?: React.ReactNode;
}

export default function FooterButton(props: Props) {
  const [bgColor, setBgColor] = useState(props.bgColor);

  // 为了防止露底，如果没传入背景色，会取body的背景色。
  useEffect(() => {
    if (!bgColor) {
      const { backgroundColor } = getComputedStyle(
        document.getElementById('micro-root') as HTMLElement
      );

      setBgColor(backgroundColor || '');
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className={styles.container}>
      <div
        className={cn(styles.footerButton, props.className, {
          [styles.fixed]: props.fixed,
          [styles.round]: props.round,
          [styles.showBorderTop]: props.showBorderTop,
        })}
        style={{ backgroundColor: bgColor, padding: props.evaluatePadding }}
      >
        {props.extra}
        <div
          className={cn(styles.main, props.btnClassName, {
            [styles.reverse]: props.reverse,
            [styles.round]: props.round,
            [styles.disabled]: props.disabled,
          })}
          onClick={props.disabled ? undefined : props.onClick}
        >
          {props.title}
        </div>
      </div>
    </div>
  );
}

FooterButton.defaultProps = {
  fixed: true,
  round: true,
  reverse: false,
};
